import _toConsumableArray from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Select/select';
import formStyles from '@patternfly/react-styles/css/components/Form/form';
import { css } from '@patternfly/react-styles';
import { SelectOption } from './SelectOption';
import { SelectConsumer, SelectVariant } from './selectConstants';
import { FocusTrap } from '../../helpers';
export var SelectMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectMenu, _React$Component);

  function SelectMenu() {
    _classCallCheck(this, SelectMenu);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectMenu).apply(this, arguments));
  }

  _createClass(SelectMenu, [{
    key: "extendChildren",
    value: function extendChildren() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          isGrouped = _this$props.isGrouped;
      var childrenArray = children;

      if (isGrouped) {
        var index = 0;
        return React.Children.map(childrenArray, function (group) {
          return React.cloneElement(group, {
            titleId: group.props.label.replace(/\W/g, '-'),
            children: group.props.children.map(function (option) {
              return _this.cloneOption(option, index++);
            })
          });
        });
      }

      return React.Children.map(childrenArray, function (child, index) {
        return _this.cloneOption(child, index);
      });
    }
  }, {
    key: "cloneOption",
    value: function cloneOption(child, index) {
      var _this$props2 = this.props,
          selected = _this$props2.selected,
          sendRef = _this$props2.sendRef,
          keyHandler = _this$props2.keyHandler;
      var isSelected = selected && selected.constructor === Array ? selected && Array.isArray(selected) && selected.includes(child.props.value) : selected === child.props.value;
      return React.cloneElement(child, {
        id: "".concat(child.props.value ? child.props.value.toString() : '', "-").concat(index),
        isSelected: isSelected,
        sendRef: sendRef,
        keyHandler: keyHandler,
        index: index
      });
    }
  }, {
    key: "extendCheckboxChildren",
    value: function extendCheckboxChildren(children) {
      var _this$props3 = this.props,
          isGrouped = _this$props3.isGrouped,
          checked = _this$props3.checked,
          sendRef = _this$props3.sendRef,
          keyHandler = _this$props3.keyHandler,
          hasInlineFilter = _this$props3.hasInlineFilter;
      var index = hasInlineFilter ? 1 : 0;

      if (isGrouped) {
        return React.Children.map(children, function (group) {
          if (group.type === SelectOption) {
            return group;
          }

          return React.cloneElement(group, {
            titleId: group.props.label.replace(/\W/g, '-'),
            children: React.createElement("fieldset", {
              "aria-labelledby": group.props.label.replace(/\W/g, '-'),
              className: css(styles.selectMenuFieldset)
            }, group.props.children.map(function (option) {
              return React.cloneElement(option, {
                isChecked: checked && checked.includes(option.props.value),
                sendRef: sendRef,
                keyHandler: keyHandler,
                index: index++
              });
            }))
          });
        });
      }

      return React.Children.map(children, function (child) {
        return React.cloneElement(child, {
          isChecked: checked && checked.includes(child.props.value),
          sendRef: sendRef,
          keyHandler: keyHandler,
          index: index++
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /* eslint-disable @typescript-eslint/no-unused-vars */
      var _a = this.props,
          children = _a.children,
          isCustomContent = _a.isCustomContent,
          className = _a.className,
          isExpanded = _a.isExpanded,
          openedOnEnter = _a.openedOnEnter,
          selected = _a.selected,
          checked = _a.checked,
          isGrouped = _a.isGrouped,
          sendRef = _a.sendRef,
          keyHandler = _a.keyHandler,
          maxHeight = _a.maxHeight,
          noResultsFoundText = _a.noResultsFoundText,
          createText = _a.createText,
          ariaLabel = _a['aria-label'],
          ariaLabelledBy = _a['aria-labelledby'],
          hasInlineFilter = _a.hasInlineFilter,
          props = __rest(_a, ["children", "isCustomContent", "className", "isExpanded", "openedOnEnter", "selected", "checked", "isGrouped", "sendRef", "keyHandler", "maxHeight", "noResultsFoundText", "createText", 'aria-label', 'aria-labelledby', "hasInlineFilter"]);
      /* eslint-enable @typescript-eslint/no-unused-vars */


      return React.createElement(SelectConsumer, null, function (_ref) {
        var variant = _ref.variant;
        return React.createElement(React.Fragment, null, isCustomContent && React.createElement("div", Object.assign({
          className: css(styles.selectMenu, className)
        }, maxHeight && {
          style: {
            maxHeight: maxHeight,
            overflow: 'auto'
          }
        }, props), children), variant !== SelectVariant.checkbox && !isCustomContent && React.createElement("ul", Object.assign({
          className: css(styles.selectMenu, className),
          role: "listbox"
        }, maxHeight && {
          style: {
            maxHeight: maxHeight,
            overflow: 'auto'
          }
        }, props), _this2.extendChildren()), variant === SelectVariant.checkbox && !isCustomContent && React.Children.count(children) > 0 && React.createElement(FocusTrap, {
          focusTrapOptions: {
            clickOutsideDeactivates: true
          }
        }, React.createElement("div", Object.assign({
          className: css(styles.selectMenu, className)
        }, maxHeight && {
          style: {
            maxHeight: maxHeight,
            overflow: 'auto'
          }
        }), React.createElement("fieldset", Object.assign({}, props, {
          "aria-label": ariaLabel,
          "aria-labelledby": !ariaLabel && ariaLabelledBy || null,
          className: css(formStyles.formFieldset)
        }), hasInlineFilter && [children.shift()].concat(_toConsumableArray(_this2.extendCheckboxChildren(children))), !hasInlineFilter && _this2.extendCheckboxChildren(children)))), variant === SelectVariant.checkbox && !isCustomContent && React.Children.count(children) === 0 && React.createElement("div", Object.assign({
          className: css(styles.selectMenu, className)
        }, maxHeight && {
          style: {
            maxHeight: maxHeight,
            overflow: 'auto'
          }
        }), React.createElement("fieldset", {
          className: css(styles.selectMenuFieldset)
        })));
      });
    }
  }]);

  return SelectMenu;
}(React.Component);
SelectMenu.defaultProps = {
  className: '',
  isExpanded: false,
  isGrouped: false,
  openedOnEnter: false,
  selected: '',
  maxHeight: '',
  sendRef: function sendRef() {},
  keyHandler: function keyHandler() {},
  isCustomContent: false,
  hasInlineFilter: false
};